// Конфигурация построения графа проходимости и подбора вариантов маршрута.
// Все расстояния — в пикселях подложки карты (10293 x 9643, CRS.Simple).

// Вершины ближе этого расстояния считаются одним узлом сетки. Только почти
// совпадающие точки: большая сварка сдвигает вершины (линия идёт ломаной) и
// может разнести соседние концы по разным узлам. Промахи стыков закрывает
// JUNCTION_SNAP_RADIUS_PX явным ребром.
export const NODE_WELD_RADIUS_PX = 8;

// Конец линии ближе этого расстояния к чужой линии (к середине отрезка или к
// вершине) соединяется с ней явным ребром — Т-перекрёсток или стык «конец к
// концу». По данным прода ~190 пар концов ручных линий лежат ближе 30px:
// админ «не дотягивает» линию до развилки.
export const JUNCTION_SNAP_RADIUS_PX = 60;

// Маркер точки соединяется «подходом» с ближайшей линией в этом радиусе.
// По данным прода максимальный зазор между маркером и его дорожкой — 631px.
export const POINT_ATTACH_RADIUS_PX = 700;

// Куски сетки, разорванные не больше чем на это расстояние, сшиваются
// кратчайшим ребром: недорисованный админом стык не должен разваливать
// навигацию на изолированные острова.
export const MESH_STITCH_RADIUS_PX = 150;

// Размер ячейки пространственного индекса отрезков. Порядка радиуса стыка:
// крупные ячейки на плотной сетке дают тысячи лишних кандидатов на каждый
// конец линии, мелкие — раздувают индекс длинными ручными отрезками.
export const SEGMENT_INDEX_CELL_PX = 64;

// Сколько вариантов маршрута максимум показываем пользователю в модалке.
export const MAX_ROUTE_VARIANTS = 3;

// Во сколько раз «дорожают» уже использованные рёбра при поиске альтернативы.
// Чем больше — тем сильнее альтернатива избегает кратчайшего пути.
export const ALTERNATIVE_EDGE_PENALTY = 3;

// Альтернатива длиннее кратчайшего более чем в этот коэффициент не показывается:
// предлагать путь в полтора с лишним раза длиннее бессмысленно.
export const ALTERNATIVE_MAX_LENGTH_RATIO = 1.6;

// Альтернатива, совпадающая с уже показанными вариантами больше чем на эту долю
// рёбер, считается дублем и отбрасывается.
export const ALTERNATIVE_MAX_OVERLAP = 0.7;
